function TableHeader({ animation, onDownload }) {
  return (
    <>
      <div className="card-header bg-white">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <div
              style={{
                width: "8px",
                height: "30px",
                backgroundColor: "#D18237",
                marginRight: "12px",
                borderRadius: "2px",
              }}
            />
            <div>
              <h5 className="m-0 text-dark fw-bold mt-4">
                LGS STAFF MANAGEMENT SERVICES INCORPORATED
              </h5>
              <p className="m-0 text-secondary">
                RECRUITMENT PRODUCTIVITY REPORT
              </p>
            </div>
          </div>

          <button
            className="btn btn-success text-white"
            onClick={() => onDownload()}
            style={{
              transition: `all 0.5s ease-in-out 0.4s`,
              transform: animation ? "translateY(0)" : "translateY(-10px)",
              opacity: animation ? 1 : 0,
              backgroundColor: "#D18237",
              borderColor: "#D18237",
            }}
          >
            <i className="bi bi-file-earmark-excel me-2"></i>
            Export to Excel
          </button>
        </div>
      </div>
    </>
  );
}

export default TableHeader;
